"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent.js"));
var _utils = require("../../utils/utils");
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
var _photographyClientLib = require("@wix/photography-client-lib");
var _consts = require("../consts.js");
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Infrastructure imports
var CartIntentOOI = /*#__PURE__*/function (_Component) {
  function CartIntentOOI(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    var artStoreApi = props.artStoreApi;
    _this.refreshItems = (0, _lodash.throttle)(artStoreApi.refreshCartItems, 1000);
    _this.handleCartMessageReceived = _this.handleCartMessageReceived.bind(_this);
    _this.updateCartItem = _this.updateCartItem.bind(_this);
    return _this;
  }
  /* eslint-disable no-case-declarations */
  (0, _inheritsLoose2["default"])(CartIntentOOI, _Component);
  var _proto = CartIntentOOI.prototype;
  _proto.handleCartMessageReceived = function handleCartMessageReceived(type, payload, resolve, reject) {
    var _this$props = this.props,
      artStoreApi = _this$props.artStoreApi,
      cartItems = _this$props.cartItems,
      setCartIntent = _this$props.setCartIntent,
      isMobile = _this$props.isMobile,
      closeCart = _this$props.closeCart,
      connectedProviders = _this$props.connectedProviders,
      onGoToCheckout = _this$props.onGoToCheckout;
    switch (type) {
      case _providerEvents["default"].sdkReady:
        this.updateCartItem(cartItems);
        setCartIntent(this.cartIntent);
        break;
      case _providerEvents["default"].goToCheckout:
        onGoToCheckout(payload.additionalParams);
        break;
      case _providerEvents["default"].openModal:
        var options = payload.options,
          name = payload.name;
        var provider = Object.keys(connectedProviders)[0];
        var providerData = connectedProviders[provider];
        var widgets = providerData.widgets;
        if (widgets[name] && [_consts.providerIntents.editor].includes(name)) {
          closeCart();
          this.props.toggleShopEditorPage((0, _extends2["default"])({}, options, options.urlParams, {
            name: name
          }));
          this.cartItemUpdated = true;
          resolve();
          break;
        }
        resolve();
        break;
      case _providerEvents["default"].removeFromCart:
        artStoreApi.removeFromCart({
          uuid: payload.uuid
        });
        break;
      case _providerEvents["default"].updateCartItem:
        artStoreApi.updateCartItem({
          uuid: payload.uuid,
          metadata: payload.metadata,
          quantity: payload.quantity
        });
        this.cartItemUpdated = true;
        break;
      default:
        break;
    }
  };
  _proto.updateCartItem = function updateCartItem(cartItems) {
    if (this.cartIntent) {
      this.cartIntent.postMessage(_providerEvents["default"].refreshCart, cartItems);
    }
  };
  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
    var itemStatusChanged = this.didItemsStatusChanged(this.props.cartItems, newProps.cartItems);
    var itemsCountChanged = newProps.count !== this.props.count;
    var cartItemUpdated = this.cartItemUpdated;
    // count is saved on local storage (for aviod cart count flickering), it can be different from actual cart items
    var shouldRefreshCartItems = newProps.count !== this.getCartItemsCount(newProps.cartItems);
    if (shouldRefreshCartItems) {
      this.refreshItems(newProps.connectedProviders);
    }
    if (itemStatusChanged || itemsCountChanged || cartItemUpdated) {
      this.updateCartItem(newProps.cartItems);
      this.cartItemUpdated = false;
    }
  };
  _proto.getCartItemsCount = function getCartItemsCount(cartItems) {
    var reducer = function reducer(accumulator, item) {
      return accumulator + item.quantity;
    };
    return cartItems.reduce(reducer, 0);
  };
  _proto.didItemsStatusChanged = function didItemsStatusChanged(items, newItems) {
    if (items === void 0) {
      items = [];
    }
    if (newItems === void 0) {
      newItems = [];
    }
    if (!(items.length && newItems.length)) {
      return false;
    }
    var getItemById = function getItemById(id, items) {
      return items.find(function (item) {
        return item.metadata.itemId === id;
      });
    };
    return !!newItems.find(function (newItem) {
      var item = getItemById(newItem.metadata.itemId, items);
      return item && newItem.status !== item.status;
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      isMobile = _this$props2.isMobile,
      viewMode = _this$props2.viewMode,
      wixSdk = _this$props2.wixSdk,
      connectedProviders = _this$props2.connectedProviders,
      count = _this$props2.count,
      visible = _this$props2.visible,
      closeCart = _this$props2.closeCart,
      additionalProviderParams = _this$props2.additionalProviderParams,
      consentPolicy = _this$props2.consentPolicy;
    var containerStyles = {};
    var textStyles = {};
    var headerStyles = {};
    if (visible) {
      if (this.cartIntent) {
        this.cartIntent.setTabIndex(_utils.utils.getTabIndex('cartFrame'));
      }
    }
    var customAdditionalParams = {};
    consentPolicy && (customAdditionalParams.consentPolicy = consentPolicy);
    if (additionalProviderParams) {
      var srcId = additionalProviderParams.srcId,
        appDefId = additionalProviderParams.appDefId,
        isAlbumStore = additionalProviderParams.isAlbumStore;
      srcId && (customAdditionalParams.srcId = srcId);
      appDefId && (customAdditionalParams.appDefId = appDefId);
      isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
    }
    var getClassName = function getClassName(base) {
      var cn = [base];
      if (visible) {
        cn.push(base + '-show');
      }
      cn.push(isMobile ? 'mobile' : 'desktop');
      return cn.join(' ');
    };
    var containerAttrs = {};
    // This is a workaround for a bug in the wix SDK
    // https://jira.wixpress.com/browse/SG-164
    if (viewMode === 'preview' && isMobile) {
      containerAttrs.style = {
        position: 'relative',
        width: '320px',
        height: '100vh',
        margin: '0px auto',
        overflow: 'hidden'
      };
    }
    var cartCloseImage = isMobile ? /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "27",
      height: "20",
      viewBox: "0 0 27 20"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fill: "currentcolor",
      fillRule: "nonzero",
      d: "M2.034 9.096l8.39-8.389L9.715 0 0 9.716l9.716 9.716.707-.707-8.629-8.63h25.155v-1H2.034z"
    })) : /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "15",
      height: "27",
      viewBox: "0 0 15 27"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentcolor",
      strokeWidth: "1.5",
      d: "M.728 1L13.2 13.473.473 26.201"
    }));
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, containerAttrs, {
      style: {
        visibility: visible ? 'visible' : 'hidden'
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: getClassName('overlay'),
      style: headerStyles,
      onClick: function onClick() {
        return closeCart();
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: getClassName('container')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-button",
      style: headerStyles
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "header-arrow",
      style: textStyles,
      onClick: function onClick() {
        return closeCart();
      },
      tabIndex: visible ? _utils.utils.getTabIndex('cartClose') : -1,
      "aria-label": "Close Cart",
      ref: function ref(button) {
        return _this2.closeButton = button;
      }
    }, cartCloseImage), /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-button-title",
      style: textStyles
    }, _photographyClientLib.translationUtils.getByKey('Gallery _CartView_Cart_Label') + " (" + count + ")")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "provider-container",
      style: containerStyles
    }, /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], (0, _extends2["default"])({
      api: new _WixSDKProviderApi["default"](wixSdk),
      ref: function ref(r) {
        return _this2.cartIntent = r;
      },
      intent: "cart",
      customAdditionalParams: customAdditionalParams,
      connectedProviders: connectedProviders,
      onMessageReceived: function onMessageReceived(type, payload, resolve, reject) {
        return _this2.handleCartMessageReceived(type, payload, resolve, reject);
      },
      customIframeStyle: {
        position: 'relative'
      },
      onIframeLoaded: function onIframeLoaded() {
        if (_this2.cartIntent) {
          _this2.cartIntent.postMessage(_providerEvents["default"].refreshCart, _this2.props.cartItems);
        }
      }
    }, this.props)))));
  };
  return CartIntentOOI;
}(_react.Component);
var _default = exports["default"] = CartIntentOOI;